/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L1Inputs */

const en_mk_sec_pg_l1 = /** @type {(inputs: Mk_Sec_Pg_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data isolation between companies`)
};

const id_mk_sec_pg_l1 = /** @type {(inputs: Mk_Sec_Pg_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isolasi data antar perusahaan`)
};

/**
* | output |
* | --- |
* | "Data isolation between companies" |
*
* @param {Mk_Sec_Pg_L1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l1 = /** @type {((inputs?: Mk_Sec_Pg_L1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l1(inputs)
	return en_mk_sec_pg_l1(inputs)
});